import { executeProtocol, isInHeybox } from '_lib/utils';

class PerfCollector {
  constructor() {
    this.params = {};
    this.path = `perf${window.location.pathname}`;
    this.timing =
      performance.getEntriesByType('navigation')[0] || performance.timing;
  }
  postPerfData() {
    executeProtocol({
      protocol_type: 'trackData',
      type: '4',
      path: this.path,
      addition: this.params,
    });
  }
  checkSupportPerformanceObserver(type) {
    if (!window.PerformanceObserver) return false;
    const types = PerformanceObserver.supportedEntryTypes;
    if (!types || types.indexOf(type) === -1) {
      return false;
    }
    return true;
  }
  async onLCP() {
    return new Promise((resolve) => {
      try {
        const lcpType = 'largest-contentful-paint';
        const isSupport = this.checkSupportPerformanceObserver(lcpType);
        if (!isSupport) {
          resolve();
          return;
        }
        const po = new PerformanceObserver((entryList) => {
          const entries = entryList.getEntries();
          const lastEntry = entries[entries.length - 1];
          this.params['LCP'] = lastEntry.renderTime || lastEntry.loadTime;
          resolve();
        });
        po.observe({ type: lcpType, buffered: true });
      } catch (e) {
        resolve();
      }
    });
  }
  async collectSyncVitals() {
    let dcl = this.timing.domContentLoadedEventEnd - this.timing.startTime;
    this.params['DCL'] = dcl;
    let fp = performance
      .getEntries('paint')
      .filter((entry) => entry.name == 'first-paint')[0]?.startTime;
    if (fp) {
      this.params['FP'] = fp;
    }
    let fcp = performance
      .getEntries('paint')
      .filter((entry) => entry.name == 'first-contentful-paint')[0]?.startTime;
    if (fcp) {
      this.params['FCP'] = fcp;
    }
  }
  async collectAsyncVitals() {
    await this.onLCP();
  }
}

export default {
  install(Vue) {
    let shouldCollect =
      window.location.host == 'web.xiaoheihe.cn' && isInHeybox();
    if (shouldCollect) {
      let p = new PerfCollector();
      document.onreadystatechange = function () {
        if (document.readyState === 'complete') {
          Promise.all([p.collectSyncVitals(), p.collectAsyncVitals()]).then(
            () => {
              p.postPerfData();
            },
          );
        }
      };
    }
  },
};
